const primary = '#3870C9';
export const navActiveColor = '#AE4B2B';
export const primaryColor = primary;
export const Colors = {
    grey_2: '#7F7D7C',
    grey_3: '#9F9D9B',
    grey_4: '#C6C4C2',
    grey_bg: '#F4F4F4',
    secondary: '#AE4B2B',
    primary: primary,
    dark_grey: '#75818F',
};

export default {
    light: {
        text: '#000',
        background: '#fff',
        tint: primary,
        tabIconDefault: primary,
        tabIconSelected: primary,
        primary: primary,
        surface: 'rgba(0, 0, 0, 0.05)',
    },
    dark: {
        text: '#fff',
        background: '#191a23',
        tint: primary,
        tabIconDefault: primary,
        tabIconSelected: primary,
        primary: primary,
        surface: '#22262a',
    },
};
